<template>
  <div class="firs-day-of-week-block">
    <v-layout pa-2 mt-2>
      <v-flex>
        <v-card>
          <v-card-title>
            <i class="material-icons light-blue--text">date_range</i>
            <div class="headline">&nbsp;Automatic subscription renew:</div>
          </v-card-title>
            <v-layout row wrap >
              <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
                <v-form ref="change_password" data-vv-scope="change_password" lazy-validation>
                  <v-layout row wrap>
                    <v-flex xs12 pl-2>
                      <v-checkbox
                        v-model="renew"
                        label="The fee will be charged automatically every month"
                      ></v-checkbox>
                      <!-- <v-switch v-model="renew" @change="setSubsxriptionRenew()"></v-switch> -->
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" class="submit"
                  @click="setSubsxriptionRenew()"
                  :loading="loading"
                  :disabled="loading"
                >Save</v-btn>
              </v-flex>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionRenew',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      loading: false,
      renew: this.$store.state.user.subscription_renew
    }
  },
  methods: {
    setSubsxriptionRenew () {
      this.loading = true
      this.$store.dispatch('SET_USER_SUBSCRIPTION_RENEW', this.renew).then(res => {
        this.$store.dispatch('GET_USER_DATA')
        this.loading = false
        this.$toasted.show(`Automatic subscription renew succefully ${this.renew ? 'enabled' : 'disabled'}`)
      }, err => {
        this.loading = false
        console.log('FIRST_DAY_OF_WEEK error', err)
        this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/SubscriptionRenew.vue